import { render, staticRenderFns } from "./39.vue?vue&type=template&id=15597a2f&"
import script from "./39.vue?vue&type=script&lang=js&"
export * from "./39.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports